import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../svgIcon';
import './styles.scss';

const BookmakerLink = ({
    titleText,
    bookmakerUrl,
    bookmakerName,
    phoneNumber,
    isPhone,
}) => {
    const linkHref = phoneNumber
        ? (isPhone && `tel:${phoneNumber}`) || null
        : bookmakerUrl;
    return (
        <a
            href={linkHref}
            target={phoneNumber ? null : '_blank'}
            rel="noopener noreferrer"
            className="bs-bookmakerLink__link bs-link bs-link_major"
        >
            <span className="bs-bookmakerLink__linkHeader">
                {titleText}
            </span>
            <span className="bs-bookmakerLink__linkText">
                {phoneNumber || bookmakerName}
            </span>
            <Svg
                iconName="right"
                size="Medium"
                className="bs-bookmakerLink__linkIcon"
            />
        </a>
    );
};

BookmakerLink.defaultProps = {
    titleText: '',
    bookmakerUrl: '',
    bookmakerName: '',
    phoneNumber: '',
    isPhone: false,
};

BookmakerLink.propTypes = {
    titleText: PropTypes.string,
    bookmakerUrl: PropTypes.string,
    bookmakerName: PropTypes.string,
    phoneNumber: PropTypes.string,
    isPhone: PropTypes.bool,
};

export default BookmakerLink;



// WEBPACK FOOTER //
// /src/js/common/bookmakerLink/BookmakerLink.jsx